import { CopilotIcon } from '@/components/ui/copilot-icon.component';
import { AgentMark } from '@/containers/agents/agent-mark.component';
import type { ChatTab } from './chat-tabs.util';

/**
 * Clu's mark or the agent's, at the tab's 20px unless told otherwise. Both
 * marks take the size as a number, so a Clu chat matches an agent chat at
 * every size the sidebar draws.
 */
export function ChatTabIcon({
  tab,
  size = 20,
}: {
  tab: Pick<ChatTab, 'agentId'>;
  size?: number;
}) {
  return tab.agentId ? (
    <AgentMark agentId={tab.agentId} size={size} />
  ) : (
    <span
      aria-hidden
      data-clu-mark
      className='inline-flex shrink-0'
      style={{ width: size, height: size }}
    >
      <CopilotIcon className='h-full w-full' />
    </span>
  );
}
